import styled from 'styled-components';

const DropDown = styled.div`
  --svg-size: 20px;

  position: relative;
  height: 100%;
  z-index: 2;
  background: white;

  @media (max-width: 859px) {
    width: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  @media (min-width: 860px) {
    margin-right: 10px;
  }

  .dropdown-sort__button {
    background-color: ${({ theme, isBundleTheme }) => (isBundleTheme ? theme.colors.background : 'inherit')};
    @media (max-width: 859px) {
      width: 100%;
      height: 100%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    @media (min-width: 860px) {
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      padding-left: 8px;
    }
  }

  .dropdown-sort__title {
    font-weight: var(--weight-bold);
    color: ${({ theme }) => theme.colors.gray4};
    margin-right: 4px;
  }

  .dropdown-sort__menu {
    border: 1px solid ${({ theme }) => theme.colors.gray2};
    padding: 4px;
    line-height: 2.3;
    position: absolute;
    background-color: ${({ theme }) => theme.colors.white};

    @media (max-width: 859px) {
      width: calc(100% + 1px);
      top: 100%;
      left: 0;
    }
    @media (min-width: 860px) {
      top: 36px;
      right: 0;
    }
  }

  .dropdown-sort__header {
    @media (max-width: 859px) {
      display: none;
    }
    @media (min-width: 860px) {
      display: flex;
      align-items: baseline;
    }
  }

  .dropdown-sort__heading {
    @media (max-width: 859px) {
      display: none;
    }
    @media (min-width: 860px) {
      color: ${({ theme }) => theme.colors.gray4};
    }
  }

  .dropdown-sort__radio {
    padding: 4px 14px;
    width: 180px;
    display: inline-flex;
    border-radius: 50px;
    align-items: center;
    flex-shrink: 0;
    position: relative;
    cursor: pointer;
    transition: var(--button-transition);

    &.is-checked {
      background-color: ${({ theme }) => theme.colors.highlight};
    }

    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.colors.highlight};
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;

      &:checked ~ .dropdown-sort__radio__custom {
        background-color: ${({ theme }) => theme.colors.brandDark};
        border-color: ${({ theme }) => theme.colors.brandDark};
      }
      &:hover ~ .dropdown-sort__radio__custom,
      &:focus ~ .dropdown-sort__radio__custom {
        border-color: ${({ theme }) => theme.colors.brandDark};
      }
    }
  }

  .dropdown-sort__radio__custom {
    position: relative;
    height: 16px;
    width: 16px;
    background-color: transparent;
    border: 2px solid ${({ theme }) => theme.colors.everscoreGray11};
    border-radius: 50%;

    &::after {
      position: absolute;
      content: '';
      border-radius: 0;
    }
  }

  .dropdown-sort__radio__copy {
    margin-left: 8px;
    font-size: 16px;
    font-weight: bold;
  }

  .dropdown-sort__icon {
    fill: ${({ theme }) => theme.colors.brandDark};
    height: 12px;
    width: 12px;
    transition: transform 0.5s;

    &.isOpen {
      transform: rotate(-180deg);
    }
    &.isClosed {
    }
  }
`;

export default DropDown;
